'use client';

import { useState } from 'react';
import { useTranslations } from 'next-intl';
import { FACILITY_GALLERIES } from '@/data/facilities';
import { GalleryCard } from '@/components/common/gallery-card';
import { FullscreenGalleryModal } from '@/components/common/fullscreen-gallery-modal';
import type { Gallery } from '@/types/gallery';

export function ClinicGallery() {
  const t = useTranslations('page.about.facilities');
  
  const [selectedGallery, setSelectedGallery] = useState<Gallery | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openGallery = (gallery: Gallery) => {
    setSelectedGallery(gallery);
    setIsModalOpen(true);
  };

  const closeGallery = () => {
    setIsModalOpen(false);
    setSelectedGallery(null);
  };

  return (
    <section className="py-20 bg-gray-50">
      <div className="container px-4 md:px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-teal-900 sm:text-4xl mb-4">
            {t('title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('description')}
          </p>
        </div>

        {/* Gallery Grid - Mobile first: 1 col, md: 2 cols, lg: 3 cols */}
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {FACILITY_GALLERIES.map((gallery) => (
            <GalleryCard
              key={gallery.id}
              gallery={gallery}
              onOpen={() => openGallery(gallery)}
              className="border-teal-100"
            />
          ))}
        </div>
      </div>

      {/* Fullscreen Gallery Modal */}
      <FullscreenGalleryModal
        gallery={selectedGallery}
        isOpen={isModalOpen}
        onClose={closeGallery}
      />
    </section>
  );
}
